export default __webpack_public_path__ + "static/newsletter-image-69ca4a81086342978240499a3837d109.jpg";